import type { ComponentProps } from "react";
import ContentIndex from "@/components/content/ContentIndex";
import { contentIndexProps } from "@/utils/contentProps";

export default function CompareIndex(
  props: Pick<ComponentProps<typeof ContentIndex>, "pages">,
) {
  return (
    <ContentIndex
      section="compare"
      title="Compare AI Cover and AI Voice Tools | Jammable"
      metaDescription="Side-by-side comparisons of AI cover generators and AI voice tools: features, voice libraries, training and prices, checked against each tool's own site."
      h1="Compare AI voice tools"
      intro="Honest, dated comparisons of AI cover and voice tools, including where another tool is the better pick."
      pages={props.pages}
      extra={[
        {
          label: "Weights AI alternative",
          href: "/weights-gg-alternative",
          description:
            "Weights.gg has shut down. Where to find community voices, make covers and upload your RVC models now.",
        },
      ]}
    />
  );
}

export const getStaticProps = contentIndexProps("compare");
